import { useState } from "react";

const ANIMATION_DURATION = 200;

export const useStatusCardAnimation = () => {
  const [selectedStatus, setSelectedStatus] = useState<string | null>(null);
  const [isExpanding, setIsExpanding] = useState<boolean>(false);

  const selectStatus = (statusName: string) => {
    setIsExpanding(true);

    setTimeout(() => {
      setSelectedStatus(statusName);
    }, 10);

    setTimeout(() => {
      setIsExpanding(false);
    }, ANIMATION_DURATION * 1.2);
  };

  const clearSelection = () => {
    setSelectedStatus(null);
    setIsExpanding(false);
  };

  return {
    selectedStatus,
    isExpanding,
    animationDuration: ANIMATION_DURATION,
    selectStatus,
    clearSelection
  };
};